import type { PriceListItem, PriceListOperator } from '../schema/pricelist';
import { intFromMixed, numericString } from './coerce';

export function parsePricelistArray(raw: unknown): PriceListItem[] {
    if (!Array.isArray(raw)) return [];
    return raw.map(parsePricelistItem);
}

function parsePricelistItem(raw: unknown): PriceListItem {
    const r = raw as Record<string, unknown>;
    return {
        id: intFromMixed(r.id, 0),
        operator: normaliseOperator(r.operator),
        value: numericString(r.value) ?? '0',
        price: numericString(r.price) ?? '0',
    };
}

function normaliseOperator(v: unknown): PriceListOperator {
    if (typeof v === 'string' && ['>', '<', '=', '>=', '<=', '!='].includes(v)) {
        return v as PriceListOperator;
    }
    return '=';
}
